<template>
  <div
    v-if="auth && auth?.roles"
    class="box flex flex-col divide-y divide-slate-200 shadow-md dark:divide-slate-600"
  >
    <!--region header-->
    <div class="relative flex shrink-0 items-center p-5 pt-4 pb-3">
      <div class="flex min-w-0 flex-1 flex-col gap-2">
        <div class="flex min-w-0 flex-col">
          <h2 class="truncate text-lg font-medium">{{ work.title }}</h2>
          <h3 class="text-xs font-medium">{{ work.reference }}</h3>
        </div>
        <div>
          <StatusInput
            v-if="
              cIsEditView && !cIsCustomerUser && metadata?.status && work.status
            "
            :model-value="work.status"
            :options="metadata.status"
            theme-colors
            @status-changed="(status) => mUpdateWorkStatus({ id: status })"
          />
          <BaseLabel
            v-else-if="work.status_string"
            :content="work.status_string"
            :color="work.status_color"
          />
        </div>
      </div>
    </div>
    <!--endregion-->

    <div class="flex flex-col gap-1 p-4">
      <WorkNavLink
        :route-name="cIndexRoute"
        icon="user"
        :label="$t('global.general_information')"
      />
      <WorkNavLink
        v-if="!cIsCustomerUser"
        :disabled="!cIsEditView"
        route-name="work_form_urn_route"
        icon="database"
        :label="$t('global.urn')"
      />
      <WorkNavLink
        v-if="!cIsCustomerUser"
        :disabled="!cIsEditView"
        route-name="work_form_event_list_route"
        icon="clock"
        :label="$t('global.events')"
      />
      <WorkNavLink
        v-if="!cIsCustomerUser && $can('see_tasks')"
        :disabled="!cIsEditView"
        route-name="work_form_tasks_route"
        icon="tasks"
        :label="$t('global.tasks')"
      />
    </div>

    <div v-if="!cIsCustomerUser" class="flex flex-col gap-1 p-4">
      <WorkNavLink
        :disabled="!cIsEditView"
        route-name="work_form_documents_route"
        :sub-routes="['work_form_view_document_route']"
        icon="file"
        :label="$t('global.document')"
      />
      <WorkNavLink
        :disabled="!cIsEditView"
        route-name="work_form_attachments_route"
        icon="paperclip"
        :label="$t('global.attachments')"
      />
    </div>

    <div v-if="!cIsCustomerUser" class="flex flex-col gap-1 p-4">
      <WorkNavLink
        :disabled="!cIsEditView"
        route-name="work_form_invoicing_route"
        :sub-routes="[
          'work_form_invoicing_show_route',
          'work_form_invoice_new_route',
          'work_form_purchase_order_new_route',
          'work_form_quote_new_route',
          'work_form_credit_note_new_route'
        ]"
        icon="euro-sign"
        :label="$t('global.invoicing')"
      />
    </div>

    <div v-if="!cIsCustomerUser" class="flex flex-col gap-1 p-4">
      <WorkNavLink
        :disabled="!cIsEditView"
        route-name="work_form_activities_route"
        icon="file-alt"
        :label="$t('global.activities')"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import StatusInput from '@c/addf-package/components/status/StatusInput.vue'
import WorkNavLink from './WorkNavLink.vue'

export default {
  name: 'TheWorkNav',
  components: { StatusInput, WorkNavLink },
  computed: {
    ...mapGetters({
      work: 'work/getWork',
      metadata: 'work/getWorkMetadata',
      auth: 'auth/getAuth'
    }),
    cIsEditView() {
      return this.$route.name !== 'work_form_new_route'
    },
    cIndexRoute() {
      return this.cIsEditView ? 'work_form_edit_route' : 'work_form_new_route'
    },
    cIsCustomerUser() {
      return this.auth.roles[0] === 'customer-user'
    }
  },
  methods: {
    ...mapActions({ updateWorkStatus: 'work/updateWorkStatus' }),
    mUpdateWorkStatus(newStatus) {
      this.updateWorkStatus({
        work_id: this.work.id,
        form_data: {
          status: newStatus.id
        }
      }).then(() =>
        this.$h.toastSuccess(
          this.$t('toasts.updated_m', { var: this.$t('global.work') })
        )
      )
    }
  }
}
</script>
